export default __webpack_public_path__ + "static/screen-content-cf35fa05d95ba096afbd1905cbf55eb9.gif";